<!-- Created by henian.xu on 2018/4/20. -->

<template>
  <div :class="classes">
    <div class="header">
      <div class="label">
        订单号: {{ data.orderNo }}
      </div>
      <div class="extra">
        <span class="tc-main">{{ data.statuName }}</span>
      </div>
    </div>
    <div class="body">
      <div class="express-box">
        <XIcon content="f052" />
        <div class="content">
          <div class="name">
            {{ data.expressName }}
          </div>
          <div class="code">
            {{ data.expressNumber }}
          </div>
        </div>
      </div>
    </div>
    <list
      v-if="data.orderDetailList && data.orderDetailList.length"
    >
      <div
        v-for="(item,index) in data.orderDetailList"
        :key="index"
        class="goods-wrap"
      >
        <div class="goods-title">
          {{ item.title }}
        </div>
        <div class="info">
          <div class="price">
            {{ item.price | price }}
          </div>
          <div class="quantity">
            x {{ item.quantity }}
          </div>
        </div>
      </div>
    </list>
    <div class="body">
      <div class="time-wrap">
        <div>下单时间: {{ (data.orderTime * 1000) | moment('YYYY-MM-DD HH:mm') }}</div>
        <div>付款时间: {{ (data.payTime * 1000) | moment('YYYY-MM-DD HH:mm') }}</div>
      </div>
    </div>
    <div class="footer">
      <div />
      <div><span>共计 {{ goodsQuantity }} 件商品 合计: </span><span class="price">{{ data.totalPrice | price }}</span></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HistoryOrderItem',
  data() {
    return {};
  },
  props: {
    data: {
      type: Object,
      default() {
        return {};
      },
    },
    radius: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classes() {
      const { radius } = this;
      return ['history-order-item', { radius }];
    },
    goodsQuantity() {
      return (this.data.orderDetailList || []).reduce((prev, curr) => {
        return prev + curr.quantity;
      }, 0);
    },
  },
  methods: {},
};
</script>

<style lang="scss">
.history-order-item {
  background-color: #fff;
  margin-top: $margin;
  display: block;

  &:first-child {
    margin-top: 0;
  }

  > .header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: $padding;
    border-bottom: 1px solid $color-border;
    > .label {
      flex: 1 1 1%;
    }
    > .extra {
      flex: 0 0 auto;
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      align-items: center;
      * + * {
        margin-left: $margin-small;
      }
    }
  }
  .goods-wrap {
    padding: $padding-small $padding;
    > .goods-title {
      font-weight: bold;
      line-height: 1.2;
    }
    > .info {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }
    + .goods-wrap {
      border-top: 1px solid $color-border;
    }
  }
  > .body {
    > .express-box {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      padding: $padding-small $padding;
      border-bottom: 1px solid $color-border;

      > .f-icon {
        flex: 0 0 auto;
        font-size: 0.5rem;
        margin-right: $margin-small;
      }
      > .content {
        flex: 1;
        line-height: 1.2;
        > .name {
          font-weight: bold;
        }
      }
    }
    > .time-wrap {
      padding: $padding-small $padding;
      border-bottom: 1px solid $color-border;
      color: $color-text-minor;
    }
  }
  > .footer {
    padding: $padding;
    border-top: 1px solid $color-border;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    color: $color-text-minor;
    > .ctrl {
      > .btn {
        margin-left: $margin-small;
      }
    }
  }

  &.radius {
    border-radius: $padding-small;
    overflow: hidden;
  }
}
</style>
